import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  HostBinding,
  NgZone,
  OnInit,
  Output,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from './../../services/util.service';

@Component({
  selector: 'upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UploadComponent),
      multi: true,
    },
  ],
})
export class UploadComponent implements ControlValueAccessor, OnInit {
  @Input('value') _value: String[] | String;
  @Input() disableRemove: Boolean;
  @Input() max;
  @Input() checkEncripted: Boolean;
  @Input() circledImg: Boolean;
  @Input() imageToPdfConverter: Boolean;
  @Input() attachmentType;
  @Input() productSignupId;
  @Input() uploadLoaction;
  @Input() allowedTypes;
  @Output() uploadInProgress = new EventEmitter<Boolean>();
  @Output() uploadError = new EventEmitter<any>();
  convertedUrl;
  is_safari;
  errorMessage: String;
  showErrorMessage: Boolean;
  uploadFilesInProgress = [];
  uploadprdSignUpInProgress;
  uploadFile: UploadFile;
  base64Image;
  @ViewChild('uploadedImg') pic: ElementRef;
  imgRatio = '100';
  onChange: any = () => {};
  onTouched: any = () => {};

  @HostBinding('class.circle-host')
  get isCircleHost(): boolean {
    return !!this.circledImg;
  }

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  constructor(
    private zone: NgZone,
    private utilService: UtilService,
    private domSanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // console.log(navigator.vendor);
    this.is_safari =
      navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') === -1 &&
      navigator.userAgent.indexOf('FxiOS') === -1;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  async writeValue(value) {
    this._value = value;
    if (value) {
      this.value = value;
      this.uploadFile = new UploadFile(null);
      this.uploadFile.url = value;
      this.uploadFile.baseUrl = value;
      if (this.uploadLoaction === 'prdSignUp') {
        try {
          let base64 = await this.utilService.getBase64StreamUsingS3(value);
          base64 = `data:image/jpg;base64,${base64}`;
          this.uploadFile.baseUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(base64 + '#toolbar=0&navpanes=0&scrollbar=0');
        } catch (e) {}
      } else if (this.uploadLoaction === 'ipo') {
        try {
          let base64 = await this.utilService.getBase64StreamUsingS3(value);
          base64 = `data:image/jpg;base64,${base64}`;
          this.base64Image = base64.split(';')[0].split('/')[0].indexOf('image') >= 0;
          this.uploadFile.completed = true;
          this.cdRef.detectChanges();
        } catch (e) {}
      }

      if (value.substring) {
        this.uploadFile.extension = value.substring(value.lastIndexOf('.') + 1).toLowerCase();
      }
      this.uploadFile.completed = true;
    } else {
      this.uploadFile = undefined;
    }
  }

  updateValue(value) {
    this.value = value;
    this.cdRef.detectChanges();
  }
  filesSelected(e) {
    const fileInput = e.target;

    if (fileInput) {
      this.addFile(fileInput.files[0]);
      fileInput.value = '';
    }
  }

  readFileContent(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      if (!file) {
        resolve('');
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const text = reader.result.toString();
        resolve(text);
      };

      reader.readAsText(file);
    });
  }
  removeFile() {
    this.uploadFile = undefined;
    this.updateValue(null);
  }

  changeFile() {
    this.uploadFile = undefined;
  }

  showError(errorMessage) {
    this.showErrorMessage = true;
    this.errorMessage = errorMessage;
    setTimeout(() => {
      this.showErrorMessage = false;
      setTimeout(() => {
        this.errorMessage = undefined;
      }, 1000);
    }, 3200);
  }

  async validFile(file) {
    if (this.checkEncripted && file) {
      let encripted = await this.readFileContent(file);
      if (encripted.indexOf('Encrypt') > 0) {
        this.uploadError.emit('encripted');
        return false;
      }
    }
    if (this.max && this.max < file.size) {
      this.uploadError.emit('invalid-size');
      return false;
    }
    if (this.allowedTypes && !this.allowedTypes.split(',').includes(file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase())) {
      this.uploadError.emit('invalid-file-type');
      return false;
    }
    return true;
  }
  async convertToPDF(selectedFile, uploadFile) {
    const uploadImageData = new FormData();
    uploadImageData.append('imageFile', selectedFile, selectedFile.name);
    uploadImageData.append('documentType', this.attachmentType);
    try {
      let data = await this.utilService.uploadImage(uploadImageData);
      this.updateValue(data['s3URL']);
      uploadFile.url = data['s3URL'];
      uploadFile.baseUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(data['base64'] + '#toolbar=0&navpanes=0&scrollbar=0');
      // uploadFile.secureURL = this.domSanitizer.bypassSecurityTrustResourceUrl(
      //   'https://docs.google.com/gview?url=' + uploadFile.url + '&embedded=true'
      // );
      uploadFile.extension = 'pdf';
      uploadFile.completed = true;
      this.cdRef.detectChanges();
    } catch (e) {
      this.uploadError.emit(e.message);
    }
  }
  async addFile(file: File) {
    if (!(await this.validFile(file))) {
      return;
    }
    const uploadFile = new UploadFile(file);
    this.uploadFile = uploadFile;
    this.updateUploadProgress('add', uploadFile);
    let uploadUrl;
    if (this.uploadLoaction === 'prdSignUp') {
      const uploadImageData = new FormData();
      uploadImageData.append('attachment', file, file.name);
      uploadImageData.append('documentType', this.attachmentType);
      uploadImageData.append('productSignupId', this.productSignupId);
      uploadImageData.append('fileDataJson', null);
      try {
        this.uploadprdSignUpInProgress = true;
        let data = await this.utilService.uploadSignUpAttachments(uploadImageData);
        this.updateValue(data['s3URL']);
        uploadFile.url = data['s3URL'];
        // uploadFile.baseUrl = data['base64'];
        uploadFile.baseUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(data['base64'] + '#toolbar=0&navpanes=0&scrollbar=0');
        // uploadFile.secureURL = this.domSanitizer.bypassSecurityTrustResourceUrl(
        //   'https://docs.google.com/gview?url=' + uploadFile.url + '&embedded=true'
        // );

        uploadFile.extension = 'pdf';
        uploadFile.completed = true;
        this.uploadprdSignUpInProgress = false;
      } catch (e) {
        this.uploadprdSignUpInProgress = false;
        this.uploadError.emit(e.message);
      }
    } else if (this.uploadLoaction === 'ipo') {
      try {
        const uploadImageData = new FormData();
        uploadImageData.append('attachment', file, file.name);
        this.uploadprdSignUpInProgress = true;
        let { url } = await this.utilService.uploadaunauthorizedImage(uploadImageData);
        this.makeFileRequest(url, uploadFile, () => {
          this.updateUploadProgress('remove', uploadFile);
          uploadFile.url = url.split('?')[0];
          uploadFile.extension = uploadFile.url.substring(uploadFile.url.lastIndexOf('.') + 1).toLowerCase();
          this.updateValue(uploadFile.url);
        });
        try {
          let base64 = await this.utilService.getBase64StreamUsingS3(url);
          base64 = `data:image/jpg;base64,${base64}`;
          this.uploadFile.ipoURL = base64;
          this.base64Image = base64.split(';')[0].split('/')[0].indexOf('image') >= 0;

          this.cdRef.detectChanges();
        } catch (e) {
          this.uploadprdSignUpInProgress = false;
        }
        this.uploadprdSignUpInProgress = false;
      } catch (e) {
        this.uploadprdSignUpInProgress = false;
        console.log(e);
        this.uploadError.emit(e && e.error && e.error.message);
      }
    } else if (this.imageToPdfConverter && file.type.indexOf('image') >= 0) {
      this.convertToPDF(file, uploadFile);
    } else if (this.uploadLoaction === 'public-uploads') {
      try {
        const uploadImageData = new FormData();
        uploadImageData.append('attachment', file, file.name);
        this.uploadprdSignUpInProgress = true;
        let { url } = await this.utilService.publicUploads(uploadImageData);
        this.makeFileRequest(url, uploadFile, () => {
          this.updateUploadProgress('remove', uploadFile);
          uploadFile.url = url.split('?')[0];
          uploadFile.extension = uploadFile.url.substring(uploadFile.url.lastIndexOf('.') + 1).toLowerCase();
          this.updateValue(uploadFile.url);
        });
      } catch (e) {
        this.uploadprdSignUpInProgress = false;
        this.uploadError.emit(e.message);
      }
    } else if (this.uploadLoaction === 'equity-requests') {
      try {
        const uploadImageData = new FormData();
        uploadImageData.append('attachment', file, file.name);
        this.uploadprdSignUpInProgress = true;
        let UrlData = await this.utilService.uploadPrivateFile(uploadImageData);
        this.makeFileRequest(UrlData.url, uploadFile, () => {
          this.updateUploadProgress('remove', uploadFile);
          uploadFile.url = UrlData.url;
          uploadFile.baseUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(UrlData.base64 + '#toolbar=0&navpanes=0&scrollbar=0');
          uploadFile.extension = 'pdf';
          uploadFile.completed = true;
          this.updateValue(UrlData.url);
        });
      } catch (e) {
        this.uploadprdSignUpInProgress = false;
        this.uploadError.emit(e.message);
      }
    } else {
      try {
        [uploadUrl] = await this.utilService.getFileUploadUrl(file.name, this.uploadLoaction);
        this.makeFileRequest(uploadUrl, uploadFile, () => {
          this.updateUploadProgress('remove', uploadFile);
          uploadFile.url = uploadUrl.split('?')[0];
          // uploadFile.secureURL = this.domSanitizer.bypassSecurityTrustResourceUrl(
          //   'https://docs.google.com/gview?url=' + uploadFile.url + '&embedded=true'
          // );

          uploadFile.extension = uploadFile.url.substring(uploadFile.url.lastIndexOf('.') + 1).toLowerCase();
          this.updateValue(uploadFile.url);
        });
      } catch (e) {
        this.uploadError.emit(e.message);
      }
    }
    // uploadUrl = 'https://alertsz.s3.amazonaws.com/f2300ca9-c9f6-4e01-bc19-4b7c85034e28_a.jpg?x-amz-acl=public-read-write&AWSAccessKeyId=AKIAJCXL4QUWM5PMIAQA&Expires=1509308357&Signature=9fy%2FLyXNUB1hz17Yby7ZXxhuvtw%3D';
  }
  getImagePath(url) {
    return this.domSanitizer.bypassSecurityTrustUrl(url);
    // this.cdRef.detectChanges();
  }
  updateUploadProgress(action, uploadFile) {
    // console.log(action, uploadFile);
    if (action === 'add') {
      this.uploadFilesInProgress.push(uploadFile);
    } else {
      this.uploadFilesInProgress.splice(this.uploadFilesInProgress.indexOf(uploadFile), 1);
    }
    this.uploadInProgress.emit(!!this.uploadFilesInProgress.length);
  }

  private makeFileRequest(url: string, uploadFile: UploadFile, cb): void {
    const xhr: XMLHttpRequest = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          uploadFile.completed = true;
        } else {
          uploadFile.completed = true;
          uploadFile.error = true;
          console.error(xhr.response);
        }
        cb();
      }
    };
    xhr.upload.onprogress = (event) => {
      this.zone.run(() => {
        uploadFile.progress = Math.round((event.loaded / event.total) * 100);

        if (uploadFile.progress === 100) {
          uploadFile.completed = true;
          this.cdRef.detectChanges();
        }
      });
    };
    xhr.open('PUT', url, true);
    xhr.setRequestHeader('Content-Type', 'multipart/form-data');
    xhr.send(uploadFile.file);
    this.cdRef.detectChanges();
  }
  onLoad() {
    if (this.circledImg) {
      // For circular images, let CSS handle the sizing - no need to calculate ratio
      return;
    }
    
    let ratio;
    if ((this.pic.nativeElement as HTMLImageElement).naturalWidth > (this.pic.nativeElement as HTMLImageElement).naturalHeight) {
      ratio =
        ((this.pic.nativeElement as HTMLImageElement).naturalWidth / (this.pic.nativeElement as HTMLImageElement).naturalHeight) * 100;
    } else {
      ratio =
        ((this.pic.nativeElement as HTMLImageElement).naturalHeight / (this.pic.nativeElement as HTMLImageElement).naturalWidth) * 100;
    }
    this.imgRatio = ratio.toString();
    this.cdRef.detectChanges();
  }
  // getUrl(uploadFile) {
  //   if (uploadFile) {
  //     let secureURL = this.domSanitizer.bypassSecurityTrustResourceUrl(
  //       'https://docs.google.com/gview?url=' + uploadFile + '&embedded=true'
  //     );
  //     return secureURL;
  //   }
  // }
}

class UploadFile {
  progress = 0;
  file: File;
  completed = false;
  error = false;
  isImage = false;
  url: string;
  extension: string;
  secureURL: any;
  baseUrl: any;
  ipoURL: any;
  constructor(file: File) {
    this.file = file;
    if (this.file) {
      if (!!this.file.type.match(/image\//)) {
        this.isImage = true;
      }
    }
  }
}
